export const environment = {
    production: false,
    AUTH_NAME: 'BVVS_Exam',
    
    //API_URL: 'http://localhost:3090',
   API_URL: 'https://bvvsexamapi.dhanpe.in',

};
